/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { IrrSaasCapabilities } from './irrSaasCapabilities';


export interface TenantDeploymentImportSpec { 
    /**
     * IP address of gateway
     */
    gateway_ip: string;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    capabilities?: IrrSaasCapabilities;
}
export namespace TenantDeploymentImportSpec {
}


